import euAnnexSnapshot from "../data/eu_annex_rules_snapshot.json";

export const EU_RULESET_MINIMUMS = {
  total: 2000,
  annexII: 1700,
  annexIII: 350,
};

const countEuAnnexRules = (rules = []) => {
  const euAnnexRules = rules.filter(
    (rule) => rule.jurisdiction === "EU" && ["II", "III"].includes(rule.annex)
  );

  return {
    total: euAnnexRules.length,
    annexII: euAnnexRules.filter((rule) => rule.annex === "II").length,
    annexIII: euAnnexRules.filter((rule) => rule.annex === "III").length,
  };
};

export const isCompleteEuRuleSet = (rules = []) => {
  const counts = countEuAnnexRules(rules);
  return (
    counts.total >= EU_RULESET_MINIMUMS.total &&
    counts.annexII >= EU_RULESET_MINIMUMS.annexII &&
    counts.annexIII >= EU_RULESET_MINIMUMS.annexIII
  );
};

export const resolveEuRuleSet = (rules = []) => {
  const providedCounts = countEuAnnexRules(rules);
  const providedComplete = isCompleteEuRuleSet(rules);
  const snapshotRules = euAnnexSnapshot.rules || [];
  const snapshotComplete = isCompleteEuRuleSet(snapshotRules);

  if (providedComplete) {
    return {
      rules,
      complete: true,
      source: "state",
      counts: providedCounts,
      metadata: {
        ...(euAnnexSnapshot.metadata || {}),
        status: "complete",
      },
    };
  }

  if (snapshotComplete) {
    const combinedRules = Array.from(
      new Map([...snapshotRules, ...rules].map((rule) => [rule.id, rule])).values()
    );

    return {
      rules: combinedRules,
      complete: true,
      source: "bundled_snapshot",
      counts: countEuAnnexRules(combinedRules),
      metadata: euAnnexSnapshot.metadata || {},
      providedCounts,
    };
  }

  return {
    rules,
    complete: false,
    source: "unavailable",
    counts: providedCounts,
    metadata: euAnnexSnapshot.metadata || {},
    providedCounts,
  };
};
